import { useEffect, useState } from "react";
import { BtnBox } from "../../style/common";
import Mp3Btn from "../common/mp3Btn";
import PdfBtn from "../common/pdfBtn";
import { isFilePath } from "../../utils/isFilePath";

interface DownloadBtnsProps {
  files: File[];
}

export default function DownloadBtns({ files }: DownloadBtnsProps) {
  const [pdfPath, setPdfPath] = useState<File | null>();
  const [mp3Path, setMp3Path] = useState<File | null>();

  useEffect(() => {
    if (files.length > 0) {
      const isPdfPath = isFilePath(files, "pdf")[0];
      setPdfPath(isPdfPath ? isPdfPath : null);

      const isMp3Path = isFilePath(files, "m4a")[0];
      setMp3Path(isMp3Path ? isMp3Path : null);
    }
  }, [files]);

  return (
    <BtnBox>
      {pdfPath && (
        <PdfBtn
          size="lg"
          fontSize="md"
          path={pdfPath.file_url as string}
          fileName={pdfPath.file_name_origin as string}
        />
      )}
      {mp3Path && (
        <Mp3Btn 
          size="lg"
          path={mp3Path.file_url as string}
          fileName={mp3Path.file_name_origin as string}
        />
      )}
    </BtnBox>
  );
}